import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import CompanySelection from "./companies";
import PaymentComponent from "./payment";
import Axios from "axios";
import { apiUri } from "../../config";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import { fetch_firm_settings } from "../../settings/firm/redux/actions";

const AddCompaniesFromAceAlerts = (props) => {
  const { user } = props.location.state || {};
  const [activeStep, setActiveStep] = useState(0);
  const [purchaseLimit, setPurchaseLimit] = React.useState("10");
  const [totalValue, setTotalValue] = React.useState(0);
  const [selectedList, setSelectedList] = React.useState([]);
  const selectedAceType = "2";
  const fromAceAlerts = true;
  const { companyId } = props.firmSettings;

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  function getStepContent(stepIndex) {
    const input = { handleNext, handleBack };
    switch (stepIndex) {
      case 0:
        return (
          <CompanySelection
            user={user}
            selectedAceType={selectedAceType}
            purchaseLimit={purchaseLimit}
            totalValue={totalValue}
            setTotalValue={setTotalValue}
            selectedList={selectedList}
            setSelectedList={setSelectedList}
            {...input}
          />
        );
      case 1:
        return (
          <PaymentComponent
            amount={totalValue}
            user={user}
            selectedList={selectedList}
            handleBack={handleBack}
            fromAceAlerts={fromAceAlerts}
          />
        );
      default:
        return "Unknown stepIndex";
    }
  }

  const fetchPurcheLimitForAceType = () => {
    Axios.get(`${apiUri}/register/purchaseLimit?type=paid`)
      .then((res) => {
        if (res.data.statusCode === 200 && res.data.content.purchaseLimit) {
          setPurchaseLimit(res.data.content.purchaseLimit);
        }
      })
      .catch((err) => {
        NotificationManager.error(err.message, "Failure");
      });
  };

  const getFreeAlertCompanies = () => {
    Axios.get(
      `${apiUri}/register/getSelectedCompanies/${user.registrationUuid}`
    )
      .then((res) => {
        if (
          res.status === 200 &&
          res.data &&
          res.data.statusCode === 200 &&
          !isEmpty(res.data.content)
        ) {
          setSelectedList(res.data.content);
        }
        if (
          (res.status === 404 && (res.statusMesaage || res.statusText)) ||
          (res.data.statusCode === 404 && res.data.statusMesaage)
        ) {
          NotificationManager.error(
            res.statusMesaage || res.statusText
              ? res.statusText
                ? res.statusText
                : res.statusMesaage
              : res.data.statusMesaage,
            "Failure"
          );
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  useEffect(() => {
    fetchPurcheLimitForAceType();
    if (companyId === "/FreeAlerts") {
      getFreeAlertCompanies();
    }
  }, []);

  return (
    <React.Fragment>
      <div>{getStepContent(activeStep)}</div>
      <NotificationContainer />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    firmSettings: state.firmSettings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch_firm_settings: () => dispatch(fetch_firm_settings()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddCompaniesFromAceAlerts)
);



// WEBPACK FOOTER //
// ./src/components/Register/addCompanyFromAceAlerts.jsx